import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate } from "react-router-dom";

export default function CreateMissionPage() {
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [establishmentId, setEstablishmentId] = useState("");
    const [assignedToUserId, setAssignedToUserId] = useState("");
    const [missionType, setMissionType] = useState("");
    const [instructions, setInstructions] = useState("");
    const [dueDateUtc, setDueDateUtc] = useState("");

    const [users, setUsers] = useState([]);
    const [establishments, setEstablishments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const fetchUsers = async () => {
        try {
            const res = await backEnd_request.get("/admin/UsersManagement");
            setUsers(res.data.users || []);
            console.log(res.data.users);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchEstablishments = async () => {
        try {
            const res = await backEnd_request.get("/Establishments");
            setEstablishments(res.data?.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchUsers();
        fetchEstablishments();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        const payload = {
            establishmentId: Number(establishmentId),
            assignedToUserId: Number(assignedToUserId),
            missionType: missionType.trim(),
            instructions: instructions.trim(),
            dueDateUtc: new Date(dueDateUtc).toISOString(),
        };

        try {
            await backEnd_request.post("/InspectionMissions", payload);
            navigate("/admin/inspection-missions-management", {
                state: { successMessage: "تم إسناد المهمة بنجاح ✅" },
            });
        } catch (err) {
            setErrorMessage(err.response?.data?.message || "حدث خطأ أثناء حفظ البيانات");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid py-5 bg-light" style={{ minHeight: "100vh" }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 col-xl-8">

                        {/* رأس الصفحة */}
                        <div className="mb-4 text-center">
                            <h2 className="fw-bold text-dark">إسناد مهمة جديدة</h2>
                            <p className="text-muted">قم بتعبئة البيانات أدناه لتكليف الموظف بالمهمة المطلوبة</p>
                        </div>

                        <div className="card border-0 shadow-lg p-2 p-md-4" style={{ borderRadius: "20px" }}>
                            <div className="card-body">

                                {errorMessage && (
                                    <div className="alert alert-danger border-0 shadow-sm mb-4">
                                        {errorMessage}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="row g-4">

                                        {/* الجهة / الفعالية */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold small text-uppercase text-secondary">الجهة المعنية</label>
                                            <select
                                                className="form-select bg-light border-0 py-3"
                                                style={{ borderRadius: "12px" }}
                                                value={establishmentId}
                                                onChange={(e) => setEstablishmentId(e.target.value)}
                                                required
                                            >
                                                <option value="">اختر الجهة...</option>
                                                {establishments.map((e) => (
                                                    <option key={e.establishmentId} value={e.establishmentId}>
                                                        {e.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* المسؤول المكلف */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold small text-uppercase text-secondary">المسؤول المكلف</label>
                                            <select
                                                className="form-select bg-light border-0 py-3"
                                                style={{ borderRadius: "12px" }}
                                                value={assignedToUserId}
                                                onChange={(e) => setAssignedToUserId(e.target.value)}
                                                required
                                            >
                                                <option value="">اختر الموظف المسؤول...</option>
                                                {users.map((u) => (
                                                    <option key={u.userId} value={u.userId}>
                                                        {u.firstName} {u.lastName} - {u.username}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* نوع المهمة */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold small text-uppercase text-secondary">تصنيف المهمة</label>
                                            <input
                                                type="text"
                                                className="form-control bg-light border-0 py-3"
                                                style={{ borderRadius: "12px" }}
                                                placeholder="مثلاً: متابعة ميدانية، استلام ملفات..."
                                                value={missionType}
                                                onChange={(e) => setMissionType(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* الموعد النهائي */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold small text-uppercase text-secondary">تاريخ ووقت الإنجاز</label>
                                            <input
                                                type="datetime-local"
                                                className="form-control bg-light border-0 py-3"
                                                style={{ borderRadius: "12px" }}
                                                value={dueDateUtc}
                                                onChange={(e) => setDueDateUtc(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* التعليمات */}
                                        <div className="col-12">
                                            <label className="form-label fw-bold small text-uppercase text-secondary">وصف المهمة والتعليمات</label>
                                            <textarea
                                                className="form-control bg-light border-0 py-3"
                                                style={{ borderRadius: "12px" }}
                                                rows={5}
                                                placeholder="يرجى كتابة كافة التفاصيل التي يحتاجها الموظف لإتمام المهمة..."
                                                value={instructions}
                                                onChange={(e) => setInstructions(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* أزرار الإجراءات */}
                                        <div className="col-12 mt-5 text-end">
                                            <button
                                                type="button"
                                                className="btn btn-link text-decoration-none text-muted me-3 fw-bold"
                                                onClick={() => navigate("/admin/inspection-missions-management")}
                                            >
                                                رجوع
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-primary px-5 py-3 shadow-sm fw-bold"
                                                style={{ borderRadius: "12px", minWidth: "180px" }}
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    "اسناد"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}